import { render, staticRenderFns } from "./Soundlab.vue?vue&type=template&id=16079905&scoped=true"
import script from "./Soundlab.vue?vue&type=script&lang=js"
export * from "./Soundlab.vue?vue&type=script&lang=js"
import style0 from "./Soundlab.vue?vue&type=style&index=0&id=16079905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16079905",
  null
  
)

export default component.exports